import type { FC } from 'react';

import type { IconProps } from './types';

const ArrowsRotate: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M511.999 0C228.275 0 0 230.167 0 511.999c0 28.597 23.183 51.78 51.78 51.78s51.78-23.183 51.78-51.78c0-226.298 180.345-408.44 408.44-408.44 183.65 0 283.484 83.893 345.468 152.237h-89.535c-28.597 0-51.78 23.183-51.78 51.78s23.183 51.78 51.78 51.78H972.22c17.639 0 30.584-5.099 39.12-14.121s12.66-21.968 12.66-37.658V77.534c0-28.597-23.183-51.78-51.78-51.78s-51.78 23.183-51.78 51.78v96.548C840.987 91.993 719.989 0 512 0zm460.22 460.219c-28.597 0-51.78 23.183-51.78 51.78 0 226.051-182.391 408.44-408.44 408.44-144.598 0-236.753-83.826-296.654-152.237h95.469c28.597 0 51.78-23.183 51.78-51.78s-23.183-51.78-51.78-51.78H102.886c-10.777 0-23.722 4.772-33.972 13.631s-17.807 21.804-17.807 38.149v230.043c0 14.299 5.796 27.244 15.167 36.613s22.315 15.167 36.613 15.167c28.597 0 51.78-23.183 51.78-51.78V857.2C230.108 937.669 340.412 1024 512 1024c282.081 0 511.999-229.918 511.999-511.999 0-28.597-23.183-51.78-51.78-51.78z"
      fill={color}
    />
  </svg>
);

export default ArrowsRotate;
